var LAYOUT_CLASS_PORTRAIT = "portrait";
var LAYOUT_CLASS_LANDSCAPE = "landscape";
var LAYOUT_CLASS_TICKERTAPE = "tickertape";
var LAYOUT_CLASS_SUPERWIDE = "superwide";
var LAYOUT_CLASS_SQUARE = "square";

var _getLayout = function(forceLayout) {
  // Safari throw error when trying to use const declare up their, so to silent the error
  // I've added the same set of const below too.
  // UPDATE: replace const with var !!

  var layoutClass = LAYOUT_CLASS_LANDSCAPE;
  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  if (windowWidth / windowHeight > 5.5) {
    layoutClass = LAYOUT_CLASS_TICKERTAPE;
  } else if (
    windowWidth / windowHeight < 5.5 &&
    windowWidth / windowHeight > 2.4
  ) {
    layoutClass = LAYOUT_CLASS_SUPERWIDE;
  } else if (
    windowWidth / windowHeight < 1.1 &&
    windowWidth / windowHeight > 0.7
  ) {
    layoutClass = LAYOUT_CLASS_SQUARE;
  } else if (windowHeight > windowWidth) {
    layoutClass = LAYOUT_CLASS_PORTRAIT;
  }

  // allow override request in
  if (forceLayout) {
    layoutClass = forceLayout;
  }

  switch (layoutClass) {
    case LAYOUT_CLASS_PORTRAIT:
      document.body.classList.remove(LAYOUT_CLASS_LANDSCAPE);
      document.body.classList.add(LAYOUT_CLASS_PORTRAIT);
      document.body.classList.remove(LAYOUT_CLASS_SQUARE);
      document.body.classList.remove(LAYOUT_CLASS_TICKERTAPE);
      document.body.classList.remove(LAYOUT_CLASS_SUPERWIDE);
      break;

    case LAYOUT_CLASS_SQUARE:
      document.body.classList.remove(LAYOUT_CLASS_LANDSCAPE);
      document.body.classList.remove(LAYOUT_CLASS_PORTRAIT);
      document.body.classList.add(LAYOUT_CLASS_SQUARE);
      document.body.classList.remove(LAYOUT_CLASS_TICKERTAPE);
      document.body.classList.remove(LAYOUT_CLASS_SUPERWIDE);
      break;

    case LAYOUT_CLASS_TICKERTAPE:
      document.body.classList.remove(LAYOUT_CLASS_LANDSCAPE);
      document.body.classList.remove(LAYOUT_CLASS_PORTRAIT);
      document.body.classList.remove(LAYOUT_CLASS_SQUARE);
      document.body.classList.add(LAYOUT_CLASS_TICKERTAPE);
      document.body.classList.remove(LAYOUT_CLASS_SUPERWIDE);
      break;

    case LAYOUT_CLASS_SUPERWIDE:
      document.body.classList.remove(LAYOUT_CLASS_LANDSCAPE);
      document.body.classList.remove(LAYOUT_CLASS_PORTRAIT);
      document.body.classList.remove(LAYOUT_CLASS_SQUARE);
      document.body.classList.remove(LAYOUT_CLASS_TICKERTAPE);
      document.body.classList.add(LAYOUT_CLASS_SUPERWIDE);
      break;

    default:
      // LAYOUT_CLASS_LANDSCAPE
      document.body.classList.add(LAYOUT_CLASS_LANDSCAPE);
      document.body.classList.remove(LAYOUT_CLASS_PORTRAIT);
      document.body.classList.remove(LAYOUT_CLASS_SQUARE);
      document.body.classList.remove(LAYOUT_CLASS_TICKERTAPE);
      document.body.classList.remove(LAYOUT_CLASS_SUPERWIDE);
      break;
  }

  return layoutClass;
};

export default {
  getLayout: _getLayout,
  LAYOUT_PORTRAIT: LAYOUT_CLASS_PORTRAIT,
  LAYOUT_CLASS_SQUARE: LAYOUT_CLASS_SQUARE,
  LAYOUT_LANDSCAPE: LAYOUT_CLASS_LANDSCAPE,
  LAYOUT_TICKERTAPE: LAYOUT_CLASS_TICKERTAPE,
  LAYOUT_SUPERWIDE: LAYOUT_CLASS_SUPERWIDE
};
